import { useMutation, useQueryClient } from 'react-query';
import { apiService } from '~services/ApiService';
import { Notification } from './useGetNotifications';

export const useMarkAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>(
    async (notificationId: string) => {
      await apiService.put(`notifications/${notificationId}/read`);
    },
    {
      onSuccess: (_data, notificationId) => {
        // Update the notification cache directly instead of refetching
        queryClient.setQueryData<Notification[]>('notifications', (oldData) => {
          if (!oldData) return [];
          
          return oldData.map(notification => 
            notification.id === notificationId 
              ? { ...notification, status: 'read' }
              : notification
          );
        });
        
        // Don't update unread count here - it's handled optimistically in NotificationContext
      },
      onError: () => {
        // On error, invalidate to get fresh data
        queryClient.invalidateQueries('notifications');
        queryClient.invalidateQueries('unreadNotificationsCount');
      },
    }
  );
};